import { useQuery } from "@tanstack/react-query";
import { getGroups } from "../api/groups.api";
import { useAuth } from "./AuthContext";

export const useLoadGroups = () => {
  const { user } = useAuth();

  const {
    data: groups = [],
    isLoading,
    isError,
  } = useQuery({
    queryFn: getGroups,
    queryKey: ["groups", user?.id],
    enabled: !!user,
    refetchOnWindowFocus: true,
  });

  return { groups, isLoading, isError };
};

